import ChapterMapComponent from "./ChapterMapComponent";

export default ChapterMapComponent;
